/* eslint-disable react/jsx-props-no-spreading */
import {
  Box,
  Divider,
  HStack,
  IconButton,
  Input,
  Stack,
  Text,
  useNumberInput,
} from '@chakra-ui/react';
import { FaMinus, FaPlus } from 'react-icons/fa';

import type { FullNotificationMessage } from './AssignmentNotificationsForm';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export default function AssignmentNotificationDaysBeforeDueForm() {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext<FullNotificationMessage>();

  const timeBeforeDue = watch('timeBeforeDue');

  const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } = useNumberInput({
    value: timeBeforeDue || 0,
    min: 1,
    max: 10000,
    onChange: (valueString) => {
      const value = parseInt(valueString, 10);
      if (!Number.isNaN(value)) {
        setValue('timeBeforeDue', value);
      }
    },
  });

  const incDays = getIncrementButtonProps();
  const decDays = getDecrementButtonProps();
  const inputDays = getInputProps();

  return (
    <Stack spacing={6} marginTop={6}>
      <Stack spacing={2}>
        <Text variant="createLabel">{t('notifications.daysBeforeDue')}</Text>

        <HStack>
          <IconButton
            {...decDays}
            size="sm"
            variant="createNumberStepper"
            isRound
            icon={<FaMinus />}
            aria-label="Decrease days"
          />

          <Box width={16}>
            <Input {...inputDays} variant="createNumber" fontSize="14px" fontWeight={600} />
          </Box>

          <IconButton
            {...incDays}
            size="sm"
            variant="createNumberStepper"
            isRound
            icon={<FaPlus />}
            aria-label="Increase days"
          />
        </HStack>
      </Stack>

      <Divider />
    </Stack>
  );
}
